import { createSlice } from "@reduxjs/toolkit";

const modalSlice = createSlice({
  name: "modal",
  initialState: {
    showSignupModal: false,
    signupModalView: 0,
    emailSignupModalView: 0,

    showCreatePlaceModal: false,
    showEditPlaceMmodal: false,
    showViewPlaceModal: false,
    showCreateProfileModal: false,
    showEditProfileModal: false,
  },
  reducers: {
    setShowSignupModal: (state, action) => {
      state.showSignupModal = action.payload;
    },
    setSignupModalView: (state, action) => {
      state.signupModalView = action.payload;
    },
    setEmailSignupModalView: (state, action) => {
      state.emailSignupModalView = action.payload;
    },

    setShowCreatePlaceModal: (state, action) => {
      state.showCreatePlaceModal = action.payload;
    },
    setShowEditPlaceModal: (state, action) => {
      state.showEditPlaceMmodal = action.payload;
    },
    setShowViewPlaceModal: (state, action) => {
      state.showViewPlaceModal = action.payload;
    },
    setShowCreateProfileModal: (state, action) => {
      state.showCreateProfileModal = action.payload;
    },
    setShowEditProfileModal: (state, action) => {
      state.showEditProfileModal = action.payload;
    },
  },
});

export default modalSlice;
